import { Button } from 'antd';
import { signOut } from '@triare/auth-redux/dist/saga/auth/signOut';
import Simple from '../../components/Layout/Simple';
import Wrapper from '../../components/Pages/Auth/Wrapper';
import store from '../../store';

import styles from './index.module.scss';

export default function AccessDenied(): JSX.Element {
  document.title = `${process.env.REACT_APP_TITLE}: Access denied`;

  return (
    <Simple>
      <Wrapper>
        <div className={styles.message}>You are not allowed to be in this app.</div>
        <Button type="primary" size="large" block onClick={() => store.dispatch(signOut())}>
          Log out
        </Button>
      </Wrapper>
    </Simple>
  );
}
